import {
    FETCH_DOCUMENT_FIELDS,
    FETCH_DOCUMENT_FIELDS_SUCCESS,
    FETCH_DOCUMENT_FIELDS_FAILED,
    UPDATE_DOCUMENT_FIELDS,
} from "../store/types";

const initialState = {
    data: [],
    loading: false,
    error: null,
};

export const documentFieldsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DOCUMENT_FIELDS:
            return {
                ...state,
                loading: true,
            };
        case FETCH_DOCUMENT_FIELDS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case UPDATE_DOCUMENT_FIELDS:
            return state;
        case FETCH_DOCUMENT_FIELDS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default documentFieldsReducer;
